// LC Constants

export const COLORS = {
  LCBlue: "#113b5e",
  LCTrueBlue: "#1c5291",
  LCSkyBlue: "#82cde5",
};

